import SpecialOffer from './pictograms/special_offer.svg';
import MoneyBackEur from './pictograms/money_back_eur.svg';
import MoneyBackGbp from './pictograms/money_back_gbp.svg';
import MoneyBackUsd from './pictograms/money_back_usd.svg';
import PageviewsDouble from './pictograms/pageviews_double.svg';
import PageviewsMultiple from './pictograms/pageviews_multiple.svg';
import PageviewsSingle from './pictograms/pageviews_single.svg';
import RecordingsDouble from './pictograms/recordings_double.svg';
import RecordingsMultiple from './pictograms/recordings_multiple.svg';
import RecordingsSingle from './pictograms/recordings_single.svg';
import HeatmapsTrigger from './pictograms/heatmaps_trigger.svg';
import HeatmapsMultiple from './pictograms/heatmaps_multiple.svg';
import HeatmapsSingle from './pictograms/heatmaps_single.svg';
import SurveysOffsite from './pictograms/surveys_offsite.svg';
import SurveysOnsite from './pictograms/surveys_onsite.svg';
import SurveysPopup from './pictograms/surveys_popup.svg';

export const PICTOGRAM_TOKENS = [
  'pageviews_single',
  'pageviews_double',
  'pageviews_multiple',
  'recordings_single',
  'recordings_double',
  'recordings_multiple',
  'heatmaps_single',
  'heatmaps_trigger',
  'heatmaps_multiple',
  'surveys_offsite',
  'surveys_onsite',
  'surveys_popup',
  'money_back_eur',
  'money_back_gbp',
  'money_back_usd',
  'special_offer',
] as const;

export type PictogramTokens = (typeof PICTOGRAM_TOKENS)[number];

// all svgr components are the same, so getting type of one of them as generic PictogramComponent type
type PictogramComponent = typeof SpecialOffer;

const PICTOGRAM_VARIANTS_MAP: Record<PictogramTokens, PictogramComponent> = {
  special_offer: SpecialOffer,
  money_back_usd: MoneyBackUsd,
  money_back_gbp: MoneyBackGbp,
  money_back_eur: MoneyBackEur,
  pageviews_double: PageviewsDouble,
  pageviews_multiple: PageviewsMultiple,
  pageviews_single: PageviewsSingle,
  recordings_double: RecordingsDouble,
  recordings_multiple: RecordingsMultiple,
  recordings_single: RecordingsSingle,
  heatmaps_trigger: HeatmapsTrigger,
  heatmaps_multiple: HeatmapsMultiple,
  heatmaps_single: HeatmapsSingle,
  surveys_offsite: SurveysOffsite,
  surveys_onsite: SurveysOnsite,
  surveys_popup: SurveysPopup,
};

function getVariantComponent(variant: PictogramTokens): PictogramComponent {
  return PICTOGRAM_VARIANTS_MAP[variant];
}

export interface PictogramProps {
  /**
   * Name of the pictogram variant.
   */
  variant: PictogramTokens;

  /**
   * Description to get added through title tag.
   */
  title?: string;

  /**
   * Styles override.
   */
  className?: string;
}

/**
 * Pictogram component.
 *
 * {@link https://zeroheight.com/76c439891/p/049823-pictograms Usage guidelines}
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-pictogram--pictogram Code documentation}
 *
 * @example
 * <Pictogram variant="special_offer" />
 */
export const Pictogram = ({
  className,
  variant,
  title,
}: PictogramProps): JSX.Element => {
  const VariantComponent = getVariantComponent(variant);

  return <VariantComponent className={className} title={title} />;
};

Pictogram.displayName = 'Pictogram';
